// The scanning switch shows the stored value. Without an active license it can only be switched off.
export const isArgusScanningSwitchDisabled = ({
  hasConfig,
  serviceEnabled,
  licenseActive,
  scanningEnabled,
}) => !hasConfig || !serviceEnabled || (!licenseActive && !scanningEnabled);
